import { createRouter, createWebHashHistory } from 'vue-router'
const routes = [
	{ 
		path: '/', 
		component: () => import('../components/searchPhoto.vue'),
		name: 'searchPhoto'
	}
]

// 配置路由，创建并暴露路由实例
export default createRouter({
	// 这里使用 hash 模式
	history: createWebHashHistory(),
	// routes: routes 的缩写
	routes
})

